export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00896.cb4e1580.png";